import { useContext } from "react";
import { AuthContext } from "../auth/AuthContext";

const Dashboard = () => {
  const { logoutUser } = useContext(AuthContext);

  return (
    <div>
      <h1>Dashboard</h1>
      <button onClick={logoutUser}>Logout</button>
    </div>
  );
};

export default Dashboard;
